import { IonText } from "@ionic/react";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useWorkOrderStore } from "../store/wo-order";
import { TranslationMessagesContext } from "../util/Translations";
import WorkOrderCard from "./WorkOrderCard";
import Fuse from "fuse.js";
import { maxResults } from "../hooks/useQueryExec";

const DownloadedWorkOrders: React.FC = () => {
  const downloadedWo = useWorkOrderStore((state) => state.downloadedWo);
  const { translatedMessages } = useContext(TranslationMessagesContext);
  const [searchText, setSearchText] = useState("");

  const allRows = useMemo(
    () => downloadedWo.flatMap((d) => d.row),
    [downloadedWo]
  );

  useEffect(() => {
    setFilteredRows(allRows);
  }, [allRows]);

  const [filteredRows, setFilteredRows] = useState(allRows);

  const hasDownloadedWo = downloadedWo.length > 0;
  const noResult = filteredRows.length <= 0;

  const fuse = useMemo(
    () =>
      new Fuse(allRows, {
        keys: ["Columns.Value"],
        includeScore: true,
        minMatchCharLength: 2,
        threshold: 0.5,
        shouldSort: true,
      }),
    [allRows]
  );

  const handleFilter = useCallback(
    async (queryString: string) => {
      if (queryString) {
        const res = fuse.search(queryString);
        setFilteredRows(res.map((r) => r.item).slice(0, maxResults));
      } else {
        setFilteredRows(allRows.slice(0, maxResults));
      }
      setSearchText(queryString);
    },
    [allRows, fuse]
  );

  return (
    <>
      {hasDownloadedWo && (
        <WorkOrderCard
          woLink={downloadedWo.at(0)?.woLink ?? ""}
          storesRoute={downloadedWo.at(0)?.storesRoute}
          storesTab={downloadedWo.at(0)?.storesTab}
          allRows={allRows}
          filteredRows={filteredRows}
          filterString={searchText}
          onFilter={handleFilter}
        />
      )}
      <IonText
        hidden={hasDownloadedWo && !noResult}
        color={"default"}
        style={{ padding: "16px", display: "inline-block" }}
      >
        {translatedMessages["NoResultsFound"]?.MessageText ||
          "No results found."}
      </IonText>
    </>
  );
};

export default DownloadedWorkOrders;
